import css from '@styled-system/css';
import React from 'react';
import styled from 'styled-components';
import { color, compose, layout, space, typography, } from 'styled-system';
import Text from './Text';
import theme from '../theme';
const ArrowIcon = styled.span `
  ${css({
    padding: '1',
    borderColor: 'brand',
    borderStyle: 'solid',
    borderTopWidth: '2px',
    borderRightWidth: '2px',
    borderBottomWidth: '0px',
    borderLeftWidth: '0px',
    left: '0.15em',
    position: 'relative',
    float: 'right',
    height: '2px',
    width: '2px',
    transform: 'rotate(135deg)',
})}
`;
const MenuBtnContainer = styled.button `
  ${css({
    background: 'white',
    borderColor: 'gray.6',
    borderStyle: 'solid',
    borderWidth: '1',
    boxSizing: 'border-box',
    fontFamily: 'body',
    fontSize: '0',
    minWidth: '150px',
    position: 'relative',
    px: '3',
    py: '2',
    textAlign: 'left',
})}
  ${compose(layout, space, color, typography)}
`;
function MenuButton({ onClick, label }) {
    return (React.createElement(MenuBtnContainer, { onClick: onClick },
        React.createElement(Text, { mr: "3" }, label),
        React.createElement(ArrowIcon, null)));
}
MenuButton.defaultProps = { theme };
export default MenuButton;
//# sourceMappingURL=MenuButton.js.map